import { createFileRoute } from '@tanstack/react-router'
import { RoleDetail } from '@/features/roles/role-detail'

/**
 * One role and its permission editor. The `role.view` guard lives on the
 * parent layout route, so it is not repeated here.
 *
 * `roleId` is a role uuid for a custom role and a `SystemRole` key for a
 * built-in; both are stable strings the list already holds, so the screen
 * matches on whichever it is given and shows a not-found state otherwise.
 */
export const Route = createFileRoute('/_authenticated/roles/$roleId')({
  component: RoleDetail,
})
